import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "q-ml-auto" }

import { ref } from "vue";
import { sessionApiStore } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import { CardPage, Typography, TextButton, EmailInput } from "@/components";


/**
 * Displays the forgot password page.
 */
const __default__ = {
  name: "ForgotPasswordView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const email = ref("");

/**
 * Navigates to the login page.
 */
function handleLogin() {
  navigateTo(Routes.LOGIN_ACCOUNT);
}

/**
 * Sends a password reset email.
 */
function handleReset() {
  sessionApiStore.handlePasswordReset(email.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardPage), null, {
    form: _withCtx(() => [
      _createVNode(_unref(Typography), {
        align: "center",
        variant: "title",
        el: "h1",
        value: "Forgot Password"
      }),
      (!_unref(sessionApiStore).passwordSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Typography), {
              el: "p",
              b: "2",
              value: " Please enter your email to reset your password."
            }),
            _createVNode(_unref(EmailInput), {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "error-message": _unref(sessionApiStore).passwordErrorMessage
            }, null, 8, ["modelValue", "error-message"])
          ]))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            el: "p",
            value: "If you have an existing account, your password has successfully been\n        reset. Please check your email to complete the password reset process."
          }))
    ]),
    actions: _withCtx(() => [
      (!_unref(sessionApiStore).passwordSubmitted)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            color: "primary",
            label: "Reset Password",
            disabled: email.value.length === 0,
            loading: _unref(sessionApiStore).loading,
            onClick: handleReset
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "Back To Login",
          color: "primary",
          onClick: handleLogin
        })
      ])
    ]),
    _: 1
  }))
}
}

})